import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Background from '../components/Background';

const Regenerating: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const style = (location.state as any)?.style as 'western' | 'vedic' | undefined;

  useEffect(() => {
    const t = setTimeout(() => {
      navigate('/user', { replace: true });
    }, 1400);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center px-4 sm:px-6" style={{ backgroundColor: '#050508' }}>
      <Background />
      <div className="max-w-md w-full relative z-10 animate-fade-in">
        <div className="glass-grain rounded-2xl px-8 py-10 backdrop-blur-xl border shadow-2xl text-center" style={{
          borderColor: 'rgba(255, 184, 79, 0.25)',
          backgroundColor: 'rgba(20, 20, 32, 0.35)'
        }}>
          <div className="relative w-16 h-16 mx-auto mb-4">
            <div className="absolute inset-0 rounded-full border-2 animate-spin" style={{ borderColor: 'rgba(255, 184, 79, 0.3)', borderTopColor: '#FFB84F' }} />
          </div>
          <h2 className="text-2xl font-heading text-gradient-gold mb-2 tracking-luxury">Regenerating</h2>
          <p className="text-text-secondary font-elegant">
            {style ? `Regenerated for ${style === 'vedic' ? 'Vedic' : 'Western'}.` : 'Updating your cosmic profile…'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Regenerating;


